// BrimLight/client/helpers/video-editor/StoryEditorFormConfig.js
import StorySchema from "../../../schemas/collections/stories.js";

export function getStoryEditorFormConfig() {
    return {
        schema: StorySchema,
        layout: 'standard',
        containerClass: '', // No extra card styling
        // REMOVED hideHeader and actions from here
        fields: {
            logline: { type: 'textarea', label: 'Logline', rows: 2 },
            fullStoryText: { type: 'textarea', label: 'Full Story Text', rows: 10 },
            characterIds: { type: 'TagInput', label: 'Associated Characters', component: 'TagInput', optionsSourceRpc: 'CharacterRpc.getFieldValues' },
            environmentIds: { type: 'TagInput', label: 'Associated Environments', component: 'TagInput', optionsSourceRpc: 'EnvironmentRpc.getFieldValues' },
            propIds: { type: 'TagInput', label: 'Associated Props', component: 'TagInput', optionsSourceRpc: 'PropRpc.getFieldValues' }
        }
    };
}
